// extracted by mini-css-extract-plugin
export default {"modal-footer":"modal-footer-_fuZTMd"};